export const DEFAULT_COLORS = [
  '#FF0001',
  '#FF4401',
  '#D66F01',
  '#FFC503',
  '#E0EA03',
  '#76D102',
  '#01FFAB',
  '#00FFE7',
  '#00B2FF',
  '#3409FF',
  '#9E07FF',
  '#FF03FD',
];

export default function frequencyToColor(
  p,
  freq,
  level,
  drawConfiguration = {},
) {
  const COLORS = drawConfiguration.colors || DEFAULT_COLORS;
  const NOTE_FREQUENCIES = [
    16.35,
    17.32,
    18.35,
    19.45,
    20.6,
    21.83,
    23.12,
    24.5,
    25.96,
    27.5,
    29.14,
    30.87,
  ];
  let i = 0;
  let j = 0;
  while (i < 200) {
    NOTE_FREQUENCIES.push(NOTE_FREQUENCIES[j] * 2);
    j++;
    i++;
  }
  const NOTES = [
    'C',
    'C#',
    'D',
    'D#',
    'E',
    'F',
    'F#',
    'G',
    'G#',
    'A',
    'A#',
    'B',
  ];

  if (level < 0.001) {
    return {color: 'black'};
  }

  // const nfreq = normalizeToFit(NOTE_FREQUENCIES, freq);
  p.fill(0);
  // text ('Estimated Low Frequency: ' + nfreq.toFixed(2), 20, 20);
  const note = findClosest(p, NOTE_FREQUENCIES, freq);
  const index = NOTE_FREQUENCIES.indexOf(note);
  const nindex = index % COLORS.length;
  const color = COLORS[nindex];
  const noteName = NOTES[nindex];
  const targetFrequency = note;

  return {color, noteName, targetFrequency};
}

function findClosest(p, arr, value) {
  const distances = arr.map(v => Math.abs(v - value));
  const mindist = p.min(distances);
  return arr[distances.indexOf(mindist)];
}



// WEBPACK FOOTER //
// ./src/sketches/frequency-to-color.js